export class ProcessingHistoryDocument {
  public constructor(
    public id: string,
    public name: string,
    public elementNumber: string,
    public theme: string,
    public elementName: string,
    public status: string,
    public webUrl: URL
  ) {}
}
